// Also installed via page.addInitScript in browser-e2e, so this must stay a self-contained
// function — it is serialized into the browser context and can't close over anything.
//
// Our ConsentManager reports activeCmps.tcf/gpp once a CMP is detected, which makes
// getPrebidConfig() configure Prebid's own GDPR/GPP enforcement with cmpApi: 'iab'. Without a real
// window.__tcfapi/__gpp, Prebid can't find a CMP and cancels the auction entirely ("GPP CMP not
// found. Canceling auction..."), hanging requestBids() forever. These stubs give Prebid a CMP that
// reports consent granted, so it proceeds normally instead.
export function installConsentApiMocks() {
    window.__tcfapi = ((command: string, _version: number, callback: (data: unknown, success: boolean) => void) => {
        if (command === 'ping') {
            callback({ gdprApplies: true, cmpLoaded: true }, true)
            return
        }
        if (command === 'addEventListener' || command === 'getTCData') {
            callback(
                {
                    // consentManagementTcf.js's checkData() requires tcString to be a non-empty
                    // string whenever gdprApplies is true, or it rejects the whole CMP response.
                    tcString: 'COuqj-POu90rDBcBkBENAZCgAPzAAAPAACiQFwwBAABAA1ADEAbQC4YAYAAgAxAG0A',
                    tcfPolicyVersion: 2,
                    cmpId: 300,
                    cmpVersion: 1,
                    gvlVersion: 3,
                    gdprApplies: true,
                    eventStatus: 'tcloaded',
                    cmpStatus: 'loaded',
                    purpose: {
                        consents: {
                            1: true,
                            2: true,
                            3: true,
                            4: true,
                            5: true,
                            6: true,
                            7: true,
                            8: true,
                            9: true,
                            10: true,
                        },
                    },
                    vendor: { consents: { 1: true } },
                },
                true,
            )
        }
    }) as Window['__tcfapi']

    window.__gpp = ((command: string, callback: (data: unknown, success: boolean) => void) => {
        const pingData = {
            gppVersion: '1.1',
            cmpStatus: 'loaded',
            cmpDisplayStatus: 'hidden',
            signalStatus: 'ready',
            supportedAPIs: ['7:usnat'],
            cmpId: 300,
            sectionList: [7],
            applicableSections: [7],
            gppString: 'DBABL~BVQqAAAAAg',
        }
        if (command === 'ping') {
            callback(pingData, true)
            return
        }
        if (command === 'addEventListener') {
            callback({ eventName: 'signalStatus', listenerId: 1, data: 'ready', pingData }, true)
            return
        }
        callback(null, true)
    }) as Window['__gpp']
}
